<template>
  <div class="setUserinfo">
    <div class="layer">
      <div class="inner">
        <button type="button" class="btnClose" @click="onClose"><span class="blind">close</span></button>
        <h2 class="layerTitle">
          {{locale.setting_set_userinfo}}
        </h2>
        <div class="userinfoList">
          <!-- 이름, 성은 고정
          <div class="userinfoItem disabled">
            <div class="checkbox">
              <div class="labelBox">
                <input type="checkbox" id="request_input_firstname" checked disabled>
                <label for="request_input_firstname">
                  <span class="badge">SYSTEM</span>
                  {{locale.first_name}}
                </label>
              </div>
            </div>
          </div>
          <div class="userinfoItem disabled">
            <div class="checkbox">
              <div class="labelBox">
                <input type="checkbox" id="request_input_lastname" checked disabled>
                <label for="request_input_lastname">
                  <span class="badge">SYSTEM</span>
                  {{locale.last_name}}
                </label>
              </div>
            </div>
          </div>
          //이름, 성은 고정 -->
          <div
            v-for="(key, index) in infoList"
            :key="index"
            class="userinfoItem"
            :class="{systemDiv: key === 'tel'}">
            <!-- 이메일, 전화번호 중 1개이상 필수 system userinfo -->
            <div v-if="!isCustom(key)">
              <div class="checkbox">
                <div class="labelBox">
                  <input type="checkbox" :id="`request_input_${key}`" v-model="info[key]">
                  <label :for="`request_input_${key}`">
                    {{getLocale(key)}}
                  </label>
                </div>
              </div>
            </div>
            <!-- //이메일, 전화번호 중 1개이상 필수 system userinfo -->
            <!-- custom userinfo -->
            <div v-else>
              <button type="button" class="btnDel" @click="delUserinfo(key)"></button>
              <div class="checkbox">
                <input type="checkbox" :id="`request_input_${key}`" v-model="info[key].active">
                <label :for="`request_input_${key}`"></label>
              </div>
              <div class="labelBox">
                <div class="translation">
                  <input type="text" class="input" v-model="info[key].label[lang.default]" @focusout="setDefaultVal(key)">
                  <button type="button" class="btnTranslation" :title="locale.language_specific_set" @click="onLanguageLayerOpen(key)">
                    <span class="blind">{{locale.language_specific_set}}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512" height="512"><g id="outline"><path d="M71.008,183.859,99,206.25A8,8,0,0,0,112,200V176h34c-.1.146-.226.283-.329.43a136.11,136.11,0,0,0,57.883,205.109c.211.086.429.164.648.234A135.616,135.616,0,0,0,256,392a137.9,137.9,0,0,0,24-2.129V440a32.032,32.032,0,0,0,32,32H424a32.032,32.032,0,0,0,32-32V367.383a39.852,39.852,0,0,0-15.008-31.242L413,313.75A8,8,0,0,0,400,320v24H359.5c2.225-2.613,4.472-5.211,6.491-7.976.031-.04.064-.076.1-.117s.057-.067.083-.1A136.03,136.03,0,0,0,256,120a137.9,137.9,0,0,0-24,2.129V80a32.032,32.032,0,0,0-32-32H88A32.032,32.032,0,0,0,56,80v72.617A39.852,39.852,0,0,0,71.008,183.859ZM408,360a8,8,0,0,0,8-8V336.641l14.992,11.992A23.906,23.906,0,0,1,440,367.383V440a16.021,16.021,0,0,1-16,16H312a16.021,16.021,0,0,1-16-16V376a16.021,16.021,0,0,1,16-16Zm-85.725-16q1.952-7.046,3.563-14.112Q335.9,332.2,346,335.273c-2.692,3.055-5.56,5.948-8.55,8.727Zm34.063-22.282q-13.658-4.4-27.277-7.5A324.916,324.916,0,0,0,334.2,264h41.5A119.068,119.068,0,0,1,356.338,321.718Zm.145-131.214A118.789,118.789,0,0,1,375.691,248H334.2a323.384,323.384,0,0,0-5.125-50.036Q342.938,194.822,356.483,190.5Zm-10.277-13.583q-10.067,3.023-20.317,5.362-3.323-14.64-8.128-29.137A119.3,119.3,0,0,1,346.206,176.921ZM264,136.314a119.479,119.479,0,0,1,33.258,7.09,298.5,298.5,0,0,1,12.961,42.11A310.41,310.41,0,0,1,264,190.167Zm0,69.881a326.175,326.175,0,0,0,49.4-5,307.007,307.007,0,0,1,4.8,46.8H264ZM264,264H318.2a308.575,308.575,0,0,1-4.8,46.941A326.084,326.084,0,0,0,264,305.829Zm0,57.831a310.731,310.731,0,0,1,46.176,4.783q-2.089,9.087-4.726,18.071a31.955,31.955,0,0,0-25.195,28.8A118.573,118.573,0,0,1,264,375.64ZM155.512,190.512q12.942,4.15,25.833,7.111A325.253,325.253,0,0,0,176.2,248H136.309A118.879,118.879,0,0,1,155.512,190.512Zm10.257-13.577q.415-.468.838-.935h19.317c-.5,2-.951,3.96-1.406,5.941Q175.164,179.765,165.769,176.935ZM155.384,321.26A118.849,118.849,0,0,1,136.308,264h39.9a324.516,324.516,0,0,0,5.138,50.2Q168.435,317.155,155.384,321.26Zm10.259,13.609q9.494-2.819,18.891-4.982,3.207,14.038,7.67,27.719A120.364,120.364,0,0,1,165.643,334.869ZM248,375.671a121.547,121.547,0,0,1-35.183-7.794,298.271,298.271,0,0,1-12.623-41.254A302.426,302.426,0,0,1,248,321.765Zm0-69.86a332.354,332.354,0,0,0-50.989,5.142A307.941,307.941,0,0,1,192.2,264H248ZM248,248H192.2a308.706,308.706,0,0,1,4.8-47.084A325.631,325.631,0,0,0,248,206.191ZM232,144v-5.54a118.972,118.972,0,0,1,16-2.106v53.814a309.782,309.782,0,0,1-47.824-4.93q1.1-4.733,2.369-9.5A31.932,31.932,0,0,0,232,144ZM72,80A16.021,16.021,0,0,1,88,64H200a16.021,16.021,0,0,1,16,16v64a16.021,16.021,0,0,1-16,16H104a8,8,0,0,0-8,8v15.359L81.008,171.367A23.906,23.906,0,0,1,72,152.617Z"/><circle cx="144" cy="108" r="12"/><circle cx="188" cy="108" r="12"/><circle cx="100" cy="108" r="12"/><circle cx="368" cy="412" r="12"/><circle cx="412" cy="412" r="12"/><circle cx="324" cy="412" r="12"/></g></svg>
                  </button>
                </div>
              </div>
              <div class="typeBox">
                <div
                  v-for="type in types"
                  :key="type"
                  :class="{active: info[key].type === type}"
                  class="userinfoType">
                  <input type="radio" :id="`request_type_${key}_${type}`" :value="type" v-model="info[key].type">
                  <label :for="`request_type_${key}_${type}`">
                    <img :src="require(`@/assets/img/modules/ico_${type}.png`)" alt="">
                    <span class="typeDesc">{{locale[`editor_module_${type}`]}}</span>
                  </label>
                </div>
              </div>
              <div v-if="info[key].type === 'select'" class="valueList">
                <div class="mb10">
                  {{locale.select_option}}
                  <button type="button" class="btn sizeXs btnWhite" @click="addValue(info[key], 'selectOption')">{{locale.add}}</button>
                </div>
                <div
                  v-for="(value, i) in info[key].selectOption"
                  :key="i"
                  class="valueItem">
                  <button type="button" class="btnDel" @click="delValueOption(key, i)"></button>
                  <div class="translation">
                    <input type="text" class="input" v-model="value[lang.default]" @focusout="setDefaultTypeVal(key, 'selectOption', i)">
                    <button type="button" class="btnTranslation" :title="locale.language_specific_set" @click="onTypeLanguageLayerOpen(key, 'selectOption', i)">
                      <span class="blind">{{locale.language_specific_set}}</span>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512" height="512"><g id="outline"><path d="M71.008,183.859,99,206.25A8,8,0,0,0,112,200V176h34c-.1.146-.226.283-.329.43a136.11,136.11,0,0,0,57.883,205.109c.211.086.429.164.648.234A135.616,135.616,0,0,0,256,392a137.9,137.9,0,0,0,24-2.129V440a32.032,32.032,0,0,0,32,32H424a32.032,32.032,0,0,0,32-32V367.383a39.852,39.852,0,0,0-15.008-31.242L413,313.75A8,8,0,0,0,400,320v24H359.5c2.225-2.613,4.472-5.211,6.491-7.976.031-.04.064-.076.1-.117s.057-.067.083-.1A136.03,136.03,0,0,0,256,120a137.9,137.9,0,0,0-24,2.129V80a32.032,32.032,0,0,0-32-32H88A32.032,32.032,0,0,0,56,80v72.617A39.852,39.852,0,0,0,71.008,183.859ZM408,360a8,8,0,0,0,8-8V336.641l14.992,11.992A23.906,23.906,0,0,1,440,367.383V440a16.021,16.021,0,0,1-16,16H312a16.021,16.021,0,0,1-16-16V376a16.021,16.021,0,0,1,16-16Zm-85.725-16q1.952-7.046,3.563-14.112Q335.9,332.2,346,335.273c-2.692,3.055-5.56,5.948-8.55,8.727Zm34.063-22.282q-13.658-4.4-27.277-7.5A324.916,324.916,0,0,0,334.2,264h41.5A119.068,119.068,0,0,1,356.338,321.718Zm.145-131.214A118.789,118.789,0,0,1,375.691,248H334.2a323.384,323.384,0,0,0-5.125-50.036Q342.938,194.822,356.483,190.5Zm-10.277-13.583q-10.067,3.023-20.317,5.362-3.323-14.64-8.128-29.137A119.3,119.3,0,0,1,346.206,176.921ZM264,136.314a119.479,119.479,0,0,1,33.258,7.09,298.5,298.5,0,0,1,12.961,42.11A310.41,310.41,0,0,1,264,190.167Zm0,69.881a326.175,326.175,0,0,0,49.4-5,307.007,307.007,0,0,1,4.8,46.8H264ZM264,264H318.2a308.575,308.575,0,0,1-4.8,46.941A326.084,326.084,0,0,0,264,305.829Zm0,57.831a310.731,310.731,0,0,1,46.176,4.783q-2.089,9.087-4.726,18.071a31.955,31.955,0,0,0-25.195,28.8A118.573,118.573,0,0,1,264,375.64ZM155.512,190.512q12.942,4.15,25.833,7.111A325.253,325.253,0,0,0,176.2,248H136.309A118.879,118.879,0,0,1,155.512,190.512Zm10.257-13.577q.415-.468.838-.935h19.317c-.5,2-.951,3.96-1.406,5.941Q175.164,179.765,165.769,176.935ZM155.384,321.26A118.849,118.849,0,0,1,136.308,264h39.9a324.516,324.516,0,0,0,5.138,50.2Q168.435,317.155,155.384,321.26Zm10.259,13.609q9.494-2.819,18.891-4.982,3.207,14.038,7.67,27.719A120.364,120.364,0,0,1,165.643,334.869ZM248,375.671a121.547,121.547,0,0,1-35.183-7.794,298.271,298.271,0,0,1-12.623-41.254A302.426,302.426,0,0,1,248,321.765Zm0-69.86a332.354,332.354,0,0,0-50.989,5.142A307.941,307.941,0,0,1,192.2,264H248ZM248,248H192.2a308.706,308.706,0,0,1,4.8-47.084A325.631,325.631,0,0,0,248,206.191ZM232,144v-5.54a118.972,118.972,0,0,1,16-2.106v53.814a309.782,309.782,0,0,1-47.824-4.93q1.1-4.733,2.369-9.5A31.932,31.932,0,0,0,232,144ZM72,80A16.021,16.021,0,0,1,88,64H200a16.021,16.021,0,0,1,16,16v64a16.021,16.021,0,0,1-16,16H104a8,8,0,0,0-8,8v15.359L81.008,171.367A23.906,23.906,0,0,1,72,152.617Z"/><circle cx="144" cy="108" r="12"/><circle cx="188" cy="108" r="12"/><circle cx="100" cy="108" r="12"/><circle cx="368" cy="412" r="12"/><circle cx="412" cy="412" r="12"/><circle cx="324" cy="412" r="12"/></g></svg>
                    </button>
                  </div>
                </div>
              </div>
              <div v-if="info[key].type === 'input'" class="fieldOption">
                <div class="checkbox">
                  <input type="checkbox" :id="`translate_${key}`" v-model="info[key].translate">
                  <label :for="`translate_${key}`">{{locale.support_translate}}</label>
                </div>
              </div>
            </div>
            <!-- //custom userinfo -->
          </div>
          <button type="button" class="btn btnWhite addUserinfo" @click="add">{{locale.add}}</button>
          <div class="btns">
            <button
              type="button"
              class="btn btnPrimary btnFull" @click="apply">{{locale.apply}}</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 언어별 세팅 -->
    <LangValue v-show="layer" :langValue="langValue" :title="locale.language_specific_set" @close="onLanguageLayerClose" />
    <!-- //언어별 세팅 -->
  </div>
</template>

<script>
import LANG from '@/common/lang'
import UNIQUE from '@/common/unique'
import LangValue from '@/components/Util/LangValue.vue'
import UTIL from '@/common/util'
import regExp from '@/common/regExp'

export default {
  name: 'SetUserinfo',
  components: {
    LangValue
  },
  props: [
    'locale',
    'userinfo'
  ],
  computed: {
    lang () {
      return this.$store.state.setting.lang
    },
    infoList () {
      return Object.keys(this.info).map(x => x)
    }
  },
  mounted () {
    if (this.userinfo) {
      this.info = this._.cloneDeep(this.userinfo)
    }
  },
  data () {
    return {
      info: {},
      types: [
        'input',
        'select'
      ],
      layer: false,
      langValue: {}
    }
  },
  methods: {
    add () {
      const newItem = {
        id: `custom_${UNIQUE.mid()}`,
        type: 'input',
        label: this.$store.getters['setting/getLangValues'](),
        inputValue: '',
        selectOption: [this.$store.getters['setting/getLangValues']()],
        active: true
      }
      this.info = {
        ...this.info,
        [newItem.id]: newItem
      }
    },
    delUserinfo (id) {
      if (window.confirm(this.locale.confirm_delete)) {
        if (id && this.info[id]) {
          this.info = Object.keys(this.info).filter(key =>
            key !== id).reduce((obj, key) => {
            obj[key] = this.info[key]
            return obj
          }, {}
          )
        }
      }
    },
    delValueOption (id, index) {
      if (window.confirm(this.locale.confirm_delete)) {
        if (index && this.info[id]) {
          this.info[id].selectOption = this.info[id].selectOption.filter((x, i) => i !== index)
        }
      }
    },
    getLocale (key) {
      const camel = regExp.camelToSnake(key)
      return this.locale[camel]
    },
    addValue (target, typeVal) {
      target[typeVal].push(this.$store.getters['setting/getLangValues']())
    },
    isCustom (key) {
      return key.startsWith('custom')
    },
    disabledSysteminfo (key) {
      if (key === 'email') {
        return !this.info.tel && this.info.email
      } else if (key === 'tel') {
        return !this.info.email && this.info.tel
      }
    },
    setDefaultVal (key) {
      const defaultLang = this.lang.default
      const target = this.info[key].label
      const fillLangs = UTIL.fillLangs(target, target[defaultLang])
      this.info[key].label = fillLangs
    },
    onLanguageLayerOpen (key) {
      this.langValue = this.info[key].label
      this.layer = true
    },
    setDefaultTypeVal (key, typeVal, i) {
      const defaultLang = this.lang.default
      const target = this.info[key][typeVal][i]
      const fillLangs = UTIL.fillLangs(target, target[defaultLang])
      this.info[key][typeVal][i] = fillLangs
    },
    onTypeLanguageLayerOpen (key, typeVal, i) {
      this.langValue = this.info[key][typeVal][i]
      this.layer = true
    },
    onLanguageLayerClose () {
      this.langValue = {}
      this.layer = false
    },
    onClose () {
      if (window.confirm(this.locale.confirm_cancel)) {
        this.$emit('close')
      }
    },
    apply () {
      const data = this.info
      if (window.confirm(this.locale.confirm_apply)) {
        this.$emit('close')
        this.$emit('apply', data)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.layer .inner {
  max-width: 600px;
}
.layerTitle {
  display: flex;
  align-items: center;
  .checkbox {
    margin-left: auto;
    margin-right: 0;
    font-size: 14px;
  }
}
.userinfoList {
  .userinfoItem {
    position: relative;
    margin-bottom: 10px;
    padding: 10px;
    border: 1px solid $color-lgrey2;
    background-color: $color-white;
  }
  .btnDel {
    position: absolute;
    top: 0;
    right: 0;
    width: 32px;
    height: 32px;
    background: url('~@/assets/img/ico_close_black.svg') 50% 50% / 16px no-repeat;
    opacity: 0.5;
  }
  .checkbox {
    margin-right: 0;
    vertical-align: middle;
    label {
      display: inline-block;
    }
  }
  .disabled {
    background-color: rgba($color-lgrey2, 0.5);
    .checkbox {
      label {
        color: $color-grey;
        cursor: not-allowed;
        &:before {
          border-color: $color-grey;
          background-color: $color-grey;
        }
      }
    }
  }
}
.badge {
  display: inline-block;
  padding: 2px 8px;
  font-size: 12px;
  color: $color-white;
  vertical-align: middle;
  border-radius: 20px;
  background-color: $color-grey;
  opacity: 0.6;
}
.labelBox {
  display: inline-block;
  width: 240px;
  vertical-align: middle;
}
.typeBox {
  display: inline-block;
  margin-left: 20px;
  vertical-align: middle;
  .userinfoType {
    display: inline-block;
    margin-right: 5px;
    border: 1px solid $color-lgrey;
    background-color: $color-white;
    cursor: pointer;
    opacity: 0.5;
    label {
      display: block;
      position: relative;
      width: 54px;
      height: 40px;
      padding-top: 10px;
    }
    img {
      opacity: 0.5;
    }
    &:hover {
      .typeDesc {
        display: block;
      }
    }
    &.active {
      opacity: 1;
    }
  }
  .typeDesc {
    display: none;
    position: absolute;
    top: 100%;
    left: 50%;
    padding: 2px 8px;
    margin-top: 3px;
    font-size: 12px;
    color: $color-white;
    white-space: nowrap;
    border-radius: 4px;
    background-color: $color-dark;
    transform: translateX(-50%);
    &:before {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      left: 50%;
      width: 6px;
      height: 6px;
      margin-top: -3px;
      margin-left: -3px;
      background-color: $color-dark;
      transform: rotate(45deg);
    }
  }
}
.fieldOption {
  margin-top: 5px;
  margin-left: 28px;
}
.valueList {
  margin-top: 15px;
  margin-left: 28px;
  .valueItem {
    display: inline-block;
    position: relative;
    width: 140px;
    margin-bottom: 5px;
    margin-right: 15px;
    padding: 0 20px 0 0;
  }
  .btnDel {
    width: 20px;
    height: 20px;
    background-size: 12px;
  }
  .translation {
    .input {
      min-height: 0;
      padding: 0.4em calc(30px + 0.6em) 0.4em 0.6em;
    }
    .btnTranslation {
      width: 30px;
    }
    svg {
      width: 24px;
      height: 24px;
    }
  }
}
.btns {
  max-width: 180px;
  margin: 30px auto 0;
}
.noData {
  padding: 60px 0 90px;
  text-align: center;
  font-size: 1.2em;
}
</style>
